// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"335":"6f76ee67","453":"6c849728","510":"da0c3c93","949":"71bba060","957":"c081ee85"}[chunkId] + ".chunk.js";
};